import * as lockr from 'lockr';
import React, { useState } from 'react';
import { DEFAULT_SCORE } from '../AppContext';
import GenericModal from './Modal';
import QuestionIcon from './QuestionIcon';
import ScoreIcon from './ScoreIcon';

const ScoreAndInfo = () => {
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const scores = lockr.get('score') || DEFAULT_SCORE;

  let allScorePoints = 0;
  let winCount = 0;
  let lossCount = 0;

  Object.keys(scores).forEach((key) => {
    const value = scores[key];
    allScorePoints = allScorePoints + value;
    if (key === '0/2') {
      lossCount = lossCount + value * 2;
    }
    if (key === '1/2') {
      lossCount = lossCount + value * 1;
      winCount = winCount + value * 1;
    }
    if (key === '2/2') {
      winCount = winCount + value * 2;
    }
  });

  const winRate = (winCount / (winCount + lossCount)) * 100 || 0;

  return (
    <div className='absolute top-6 z-10 flex'>
      <span
        onClick={() => {
          setIsScoreModalOpen(true);
        }}
        className='cursor-pointer'
      >
        <ScoreIcon />
      </span>
      <GenericModal
        isOpen={isScoreModalOpen}
        onCloseModal={() => {
          setIsScoreModalOpen(false);
        }}
      >
        <h3 className='text-xl font-bold '>Skor Tablosu</h3>
        <div className='mt-6 text-lg font-bold'>
          {Object.keys(scores).map((key) => {
            const value = scores[key];
            const percentage = (value / allScorePoints) * 100;

            return (
              <div key={key} className='my-2 flex items-center justify-center'>
                <div>{key}: </div>
                <div className='w-full h-6 bg-gray-500 ml-4 relative rounded'>
                  <div style={{ width: `${Math.round(percentage * 100) / 100 || 0}%` }} className='bg-green-600 h-6 rounded'></div>
                  <div className='absolute right-2 -top-1'>{value}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className='mt-4'>
          <h3 className='text-lg font-bold'>Toplam Başarı Oranı:</h3>
          <div className='w-full h-6 bg-gray-500 mt-2 relative rounded'>
            <div style={{ width: `${winRate.toFixed(0)}%` }} className='bg-green-600 h-6 rounded'></div>
            <div className='absolute right-1/2 top-0 font-bold'>{winRate.toFixed(0)}%</div>
          </div>
        </div>
      </GenericModal>
      <span
        onClick={() => {
          setIsInfoModalOpen(true);
        }}
        className='cursor-pointer'
      >
        <QuestionIcon />
      </span>
      <GenericModal
        isOpen={isInfoModalOpen}
        onCloseModal={() => {
          setIsInfoModalOpen(false);
        }}
      >
        <h3 className='text-xl font-bold '>Bilgilendirme</h3>
        <div className='mt-5'>
          <p>Üretici oyunla ilgili herhangi bir telif hakkına sahip değildir.</p>
          <p>Orjinal Dordle oyunun Türkçe versiyonudur. </p>
          <hr className='my-10 border-gray-200' />
          <p>
            İletişim için{' '}
            <a className='underline' target='_blank' rel='no-ref noreferrer' href='https://github.com/tahaygun'>
              @tahaygun
            </a>{' '}
          </p>
          <hr className='my-10 border-gray-200' />
          <p>
            Android telefonlara app olarak indirmek icin Google Play linki burada: <br />
            <a
              target='_blank'
              rel='no-ref noreferrer'
              className='underline block pt-3'
              href='https://play.google.com/store/apps/details?id=com.dordle.app'
            >
              Dordle Türkçe Play Store
            </a>{' '}
          </p>
          <hr className='my-10 border-gray-200' />

          <p>
            4 kelimeli versiyonu, Quordle Türkçe, için{' '}
            <a className='underline' target='_blank' rel='no-ref noreferrer' href='https://quordle.netlify.app'>
              buraya tıklayın.
            </a>{' '}
          </p>
        </div>
      </GenericModal>
    </div>
  );
};

export default ScoreAndInfo;
